import { getErrorPayload } from '@application/helpers/api-helper';
import peopleAPI from '@infrastructure/people-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const getAllPeopleAsync = createAsyncThunk('people/getAll', async (params, { rejectWithValue }) => {
    try {
        const response = await peopleAPI.getAllPeople(params);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPersonByIdAsync = createAsyncThunk('people/getById', async (personId, { rejectWithValue }) => {
    try {
        const response = await peopleAPI.getPersonById(personId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPeopleForTasksAsync = createAsyncThunk('people/getAllForTasks', async (_, { rejectWithValue }) => {
    try {
        const response = await peopleAPI.getAllPeopleForTasksWithoutPagination();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPeopleWithoutPaginationAsync = createAsyncThunk('people/getAllWithoutPagination', async (params, { rejectWithValue }) => {
    try {
        const response = await peopleAPI.getAllPeopleWithoutPagination(params?.eventId, params?.searchString);
        return response.data.items;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getReferredByPersonByMvpIdAsync = createAsyncThunk('people/getReferredByPersonByMvpId', async (mvpId, { rejectWithValue }) => {
    try {
        const response = await peopleAPI.getReferredByPersonByMvpId(mvpId);
        return response.data.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPeopleRecentEvents = createAsyncThunk('people/getAllRecentEvents', async (payload, { rejectWithValue }) => {
    try {
        const response = await peopleAPI.getAllPeopleRecentEvents(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const exportPeopleToExcelAsync = createAsyncThunk('people/exportToExcel', async (payload, { rejectWithValue }) => {
    try {
        const response = await peopleAPI.exportPeopleToExcel(payload);
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `people-export-${new Date().getTime()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
